// React
import React, { useState, useEffect } from "react";

// import { Link } from "react-router-dom";

import "react-simple-flex-grid/lib/main.css";

import EditableTagGroup from "./EditableTagGroup";

// Eventify API
import * as EventifyAPI from "../libs/EventifyAPI";
import * as ModelCache from "../libs/ModelCache";
// ant design components
import { Collapse } from "antd";

const { Panel } = Collapse;
// UUID
const uuidv4 = require("uuid/v4");

// DateTime
const { DateTime } = require("luxon");

function callback(key) {
  console.log(key);
}

export default function ContactContainer({personid, ...props}) {
  const [person, setPerson] = useState({});
  const [lists, setLists] = useState([]);
  const [listsInfo, setListsInfo] = useState({});
  const [notesToUserInfo, setNotesToUserInfo] = useState({});
  const [notes, setNotes] = useState([]);

  useEffect(() => {
    onLoad();
  }, [personid]); // update every time personid changes

  async function onLoad() {
    EventifyAPI.getListsForPersonId(
      personid
    ).then(result => {
      setLists(result);
    });
    EventifyAPI.getNotesforPersonId(
      personid
    ).then(result => {
      setNotes(result);
    });
    ModelCache.getPersonForId(
      personid,
      result => {
        if (result == null || typeof result === "undefined") {
          // set placeholders
        } else {
          setPerson(result);
          }
      }
    );
  }

  function formatTime(unixTime) {
    const timeObject = DateTime.fromMillis(parseInt(unixTime)).setZone(
      "America/Los_Angeles"
    );
    const timeString = timeObject.toLocaleString(DateTime.DATE_MED);
    return <p>{timeString}</p>;
  }

  // TODO: Replace when creating view model for the side pane
  function renderIndividualList(listid) {
    return (<></>);
    // if (
    //   listsInfo[listid] === null ||
    //   typeof listsInfo[listid] === "undefined"
    // ) {
    //   ModelCache.getListForId(
    //     listid,
    //     result => {
    //       var info = listsInfo;
    //       if (result != null && typeof result !== "undefined") {
    //         info[listid] = result;
    //       } else {
    //         info[listid] = {};
    //       }
    //       setListsInfo(info);
    //       setReloadProtocol(uuidv4());
    //     }
    //   );
    //   return <></>;
    // } else {
    //   const listEntry = listsInfo[listid];
    //
    //   var notesForPerson = [];
    //   for (var k = 0; k < notes.length; k++) {
    //     const note = notes[k];
    //     if (note.listid === listid) {
    //       notesForPerson.push(note);
    //     }
    //   }
    //
    //   return (
    //     <Collapse defaultActiveKey={["1"]} onChange={callback}>
    //       <Panel header={listEntry.name} key={listEntry.listid}>
    //         <div className="top-list-info">
    //           <Link
    //             to={`list/${listEntry.listid}`}
    //             className="contactDetailsList"
    //           >
    //             Navigate to list
    //           </Link>
    //           <div className="event-date">
    //             <p className="label">Event Date:</p>
    //             {formatTime(listEntry.primaryDate)}
    //           </div>
    //         </div>
    //
    //         {notesForPerson.length > 0 ? (
    //           renderNotesForList(notesForPerson)
    //         ) : (
    //           <p>No Notes</p>
    //         )}
    //       </Panel>
    //     </Collapse>
    //   );
    // }
  }

  function renderLists(chonks) {
    return (
      <div className="list-entry">
        {chonks.map((list, n) => renderIndividualList(list.listid))}
      </div>
    );
  }

  function renderNotesForList(notes) {
    return (
      <>
        {notes.map((note, n) => (
          <div>{renderIndividualNote(note)}</div>
        ))}
      </>
    );
  }

  function renderIndividualNote(note) {
    var user = notesToUserInfo[note.userid];
    if (user === null || typeof user === "undefined") {
      ModelCache.getUserById(
        note.userid,
        user => {
          var local = notesToUserInfo;
          local[note.userid] = user;
          setNotesToUserInfo(local);
        }
      );
    }

    return (
      <div className="sidepane-note-container">
        {user !== null && typeof user !== "undefined" ? (
          <div className="sidepane-note">
            {renderUser(user)}
            <div className="noteContent">
              <p>{note.notes}</p>
              {formatTime(note.updated)}
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    );
  }

  function renderUser(user) {
    return <img className="avatar sm" src={user.picture} />;
  }

  return (
    <div className="contact-info-container">
      <div className="custom-contact-block">
        <div className="panel-section">
          <p className="label">Contact Information</p>
          <h4>
            {person.name === null || typeof person.name === "undefined"
              ? "Loading..."
              : person.name}
          </h4>
          <h6>
            {person.email === null || typeof person.email === "undefined"
              ? "Loading..."
              : person.email}
          </h6>
        </div>

        <div className="panel-section">
          <p className="label">Tags</p>
          <EditableTagGroup />
        </div>

        <div className="panel-section">
          <p className="label">Most commonly invited by:</p>
          <div className="main-referrer">
            <div className="avatar"></div>
            <div className="referrer-text">
              <h6>Referrer Name</h6>
              <p>Referrer Email</p>
            </div>
          </div>
        </div>

        <div className="panel-section">
          <p className="label">Lists</p>
          {renderLists(lists)}
        </div>
      </div>
      <div className="active custom-contact-block">
        <div className="panel-section">
          <h4>Visualizations</h4>
          <p style={{ color: "blue" }}>Coming soon!</p>
        </div>
      </div>
    </div>
  );
}
